import styled from 'styled-components';
import React, { useState } from 'react';
import { Select, type SelectOption, TextField, IconButton } from '../';
import FormControl from '@mui/material/FormControl';
import { AddCircle } from '@mui/icons-material';

export type SelectionAddProps = {
  options: SelectOption[];
  handleAdd: (value: string, option: string) => void;
};

export const SelectionAdd: React.FunctionComponent<SelectionAddProps> = (
  props: SelectionAddProps,
) => {
  const { options, handleAdd } = props;
  const [value, setValue] = useState('');
  const [targetOption, setTargetOption] = useState(options[0]);

  const handleChangeOption = (event: any): void => {
    setTargetOption(options[event.target.value]);
  };

  const handleChangeText = (event: any): void => {
    setValue(event.target.value);
  };

  return (
    <Content>
      <FormControl sx={{ m: 1, minWidth: 160 }}>
        <Select
          value={targetOption.value}
          options={options}
          onChange={handleChangeOption}
          inputProps={{ 'aria-label': 'Without label' }}
        />
      </FormControl>
      <TextField
        className="ml-1"
        value={value}
        placeholder={targetOption.label as string}
        onChange={handleChangeText}
      />
      <IconButton
        icon={<AddCircle style={{ color: '#951d1d' }} />}
        onClick={() => {
          handleAdd(value, targetOption.value as string);
        }}
      />
    </Content>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .MuiInputBase-root {
    height: 40px;
  }
  .ml-1 {
    margin-left: 1rem;
  }
`;
